module.exports = __webpack_public_path__ + "static/media/HiddenPointeBylaws.d9c00e29.pdf";